export default "__VITE_ASSET__H8lj7tTb__"